/*import React, { useState } from "react";
import "./AlertPercentageLealtad.css";
import { TiDelete } from "react-icons/ti";

const AlertPercentageLealtad = () => {
  const [AlertPercentageLealtad, setAlertPercentageLealtad] = useState(true);

  const CloseAlert = () => {
    setAlertPercentageLealtad(false);
  };

  return (
    <>
      {AlertPercentageLealtad === true ? (
        <div className="alerts-container">
          <div className="boxalertpercentageLealtad">
            <p className="textalertpercentageLealtad">
              <strong>A PARTIR DE LA VENTA DE OCTUBRE</strong>
              <br />
              <br />
              Estimado comercializador,
              <br />
              <br />
              Le informamos que, debido a los recientes aumentos en los
              créditos, las escalas de comisiones han sido ajustadas. Estas
              comisiones están indexadas al Salario Mínimo, Vital y Móvil, tal
              como lo establece el anexo correspondiente.
              <br />
              <br />
              Nuevas escalas:
              <br />
              <br />
              - Hasta $11.000.000: 7%
              <br />
              - De $11.000.001 a $20.000.000: 9%
              <br />
              - De $20.000.001 a $30.000.000: 10%
              <br />
              - Más de $30.000.001: 11%
              <br />
              <br />
              <br />
              Agradecemos su comprensión y colaboración.
              <br />
              <br />
              Atentamente,
              <br />
              Lealtad
            </p>
            <TiDelete
              className="iconalertpercentageLealtad"
              onClick={CloseAlert}
            />
          </div>
          <div className="boxalertpercentageLealtad">
            <p className="textalertpercentageLealtad">
              <strong>AVISO IMPORTANTE</strong>
              <br />
              <br />
              Estimado comercializador,
              <br />
              <br />
              Desde febrero de 2026, las comisiones se pagan el 5° día hábil. La
              factura debe cargarse hasta el 4° día hábil a las 18:00 hs.
              <br />
              <br />
              Facturas cargadas luego de ese horario se abonarán el día 15 o
              hábil siguiente. Las ventas estarán disponibles el primer día
              hábil del mes en el portal.
              <br />
              <br />
              — Comisión Directiva
              <br />
              Saludos
            </p>
            <TiDelete
              className="iconalertpercentageLealtad"
              onClick={CloseAlert}
            />
          </div>
        </div>
      ) : null}
    </>
  );
};

export default AlertPercentageLealtad;*/

import React, { useState, useEffect } from "react";
import "./AlertPercentageLealtad.css";
import { TiDelete } from "react-icons/ti";
import axios from "axios";
import { getTokenCookie } from "../../views/Login/cookie";
import { getCommissionDisplay } from "../../utils/commissions";

const AlertPercentageLealtad = () => {
  const [alertPercentageLealtad, setAlertPercentageLealtad] = useState(true);
  const [commissionDisplays, setCommissionDisplays] = useState([]);
  const [supplierName, setSupplierName] = useState("");

  const CloseAlert = () => {
    setAlertPercentageLealtad(false);
  };

  useEffect(() => {
    const fetchSupplier = async () => {
      const token = getTokenCookie();

      try {
        const response = await axios.get(
          `${process.env.REACT_APP_GET_SUPPLIER_LEALTAD}${token}`,
        );

        const name = response.data.nameAndLastName;

        setSupplierName(name);
        setCommissionDisplays(getCommissionDisplay(name));
      } catch (error) {
        setCommissionDisplays([]);
      }
    };

    fetchSupplier();
  }, []);

  return (
    <>
      {alertPercentageLealtad === true ? (
        <div className="alerts-container">
          <div className="boxalertpercentageLealtad">
            <p className="textalertpercentageLealtad">
              <strong>A PARTIR DE LA VENTA DE MAYO</strong>
              <br />
              <br />
              Estimado comercializador,
              <br />
              <br />
              Le informamos que sus escalas de comisiones han sido ajustadas.
              Estas comisiones están indexadas al Salario Mínimo, Vital y Móvil,
              tal como lo establece el anexo correspondiente.
              <br />
              <br />
              {supplierName && (
                <>
                  Comercializador: <strong>{supplierName}</strong>
                  <br />
                  <br />
                </>
              )}
              Su escala de comisión:
              <br />
              <br />
              {commissionDisplays.map((item, index) => (
                <React.Fragment key={index}>
                  {item}
                  <br />
                </React.Fragment>
              ))}
              <br />
              <br />
              Agradecemos su comprensión y colaboración.
              <br />
              <br />
              Atentamente,
              <br />
              Lealtad
            </p>

            <TiDelete
              className="iconalertpercentageLealtad"
              onClick={CloseAlert}
            />
          </div>

          <div className="boxalertpercentageLealtad">
            <p className="textalertpercentageLealtad">
              <strong>AVISO IMPORTANTE</strong>
              <br />
              <br />
              Estimado comercializador,
              <br />
              <br />
              Desde febrero de 2026, las comisiones se pagan el 5° día hábil. La
              factura debe cargarse hasta el 4° día hábil a las 18:00 hs.
              <br />
              <br />
              Facturas cargadas luego de ese horario se abonarán el día 15 o
              hábil siguiente. Las ventas estarán disponibles el primer día
              hábil del mes en el portal.
              <br />
              <br />
              — Comisión Directiva
              <br />
              Saludos
            </p>

            <TiDelete
              className="iconalertpercentageLealtad"
              onClick={CloseAlert}
            />
          </div>
        </div>
      ) : null}
    </>
  );
};

export default AlertPercentageLealtad;
